import { createRoute, Outlet } from '@tanstack/react-router';
import { rootRoute } from '../__root';

export const itemsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'items',
  component: ItemsLayout,
});

function ItemsLayout() {
  return (
    <div data-ai-id="library-items-route">
      <Outlet />
    </div>
  );
}
